import { GetterTree } from 'vuex'
import {
    Contact,
    Institution,
    Insurance,
    Period,
    WidgetState
} from "@/apps/StudentExchangeNonPartnerWidget/models/store-viewmodel"
import {ILabels, ILanguage} from "@/apps/StudentExchangeNonPartnerWidget/models/config-viewmodel";

export default <GetterTree<WidgetState, WidgetState>>{
    getState(state) {
        return state
    },
    getLoading(state): boolean {
        return state.loading
    },
    isEditable(state): boolean {
        return state.editable
    },
    isCancelable(state): boolean {
        return state.cancelable
    },
    getLabels(state): ILabels {
        return state.labels
    },
    getPeriod(state): Period {
        return state.period
    },
    getContact(state): Contact {
        return state.contact
    },
    getInstitution(state): Institution {
        return state.institution
    },
    getInsurance(state): Insurance {
        return state.insurance
    },
    getProgramId(state): number | null {
        return state.programId
    },
    getCanContinue(state): boolean {
        return state.canContinue
    },
    getExchangeId(state): string | null {
        return state.exchangeId
    },
    getLanguage(state): ILanguage {
        return state.language
    },
    getErrorMessage(state): String | null {
        return state.errorMessage
    },
    getStudyName(state): String | null {
        return state.studyName
    },
    getIsSubmitted(state): boolean {
        return state.isSubmitted
    },
    getPeriodIsInvalid(state): boolean {
        return state.periodIsInvalid
    },
    getContactIsInvalid(state): boolean {
        return state.contactIsInvalid
    }
}
